import inDOM from 'dom-helpers/canUseDOM'

const supportsCssVariables = !inDOM || (
  window.CSS &&
  window.CSS.supports &&
  window.CSS.supports('(--a: #000000)')
)

export default supportsCssVariables
